import find from 'lodash/find';

import {push} from 'router/router-actions';
import {
    retrieveSpotTravelDistance,
    retrieveAirportSpotTravelDistance,
} from 'utils/travel-distance';

export const SPOT_UPDATE_SELECTED = 'SPOT_UPDATE_SELECTED';
export const SPOT_CHANGE_MULTI_RATE = 'SPOT_CHANGE_MULTI_RATE';
export const SPOT_GET_TRAVEL_DISTANCE = 'SPOT_GET_TRAVEL_DISTANCE';
export const SPOT_GET_AIRPORT_TRAVEL_DISTANCE =
    'SPOT_GET_AIRPORT_TRAVEL_DISTANCE';
export const SPOT_RESET_SELECTED_SPOT = 'SPOT_RESET_SELECTED_SPOT';
export const SPOT_RESET_SELECTED_RATE = 'SPOT_RESET_SELECTED_RATE';

export const updateSelected = ({spot, referrer, goToSpotUrl = false} = {}) => {
    return dispatch => {
        dispatch({
            type: SPOT_UPDATE_SELECTED,
            payload: {
                spot,
                referrer,
                goToSpotUrl,
            },
        });

        if (goToSpotUrl && spot) {
            dispatch(push(spot.selectedRate.fullUrl));
        }
    };
};

// Used on search controls only
export const resetSelectedSpot = () => {
    return {
        type: SPOT_RESET_SELECTED_SPOT,
    };
};

// Used on Checkout only
export const changeMultiRate = ({newRateRule, rates}) => {
    return {
        type: SPOT_CHANGE_MULTI_RATE,
        payload: {
            newRate: find(rates, {fullRule: parseInt(newRateRule, 10)}) || null,
            rid: parseInt(newRateRule, 10),
        },
    };
};

// Used on Search only
export const getTravelDistance = spot => {
    return {
        type: SPOT_GET_TRAVEL_DISTANCE,
        payload: retrieveSpotTravelDistance(spot),
    };
};

// Used on Search only
export const getAirportTravelDistance = spot => {
    return {
        type: SPOT_GET_AIRPORT_TRAVEL_DISTANCE,
        payload: retrieveAirportSpotTravelDistance(spot),
    };
};

// Used on Checkout only
export const resetSelectedRate = () => {
    return {
        type: SPOT_RESET_SELECTED_RATE,
    };
};
